import styled from "styled-components";
import composition from "assets/images/mobile/NH21_722_ELLE_GLORIA2154.jpg";

export const Container = styled.section`
  display: flex;
  width: 100%;
  height: 100vh;
  position: relative;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const Wrapper = styled.div`
  width: 100vw;
  height: 100%;
  min-height: 100vh;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -ms-overflow-style: none; // IE
  /* overflow: -moz-scrollbars-none; // Firefox */
  scrollbar-width: none; // Firefox
  --webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none; // Chrome and Safari
  }
`;

export const Composition = styled.img.attrs({ src: composition })`
  height: 100%;
  animation-delay: 1s;
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
  animation-fill-mode: both;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
`;
